<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-task" data-toggle="modal" data-target="#exampleModal">Add</button> -->

            <div class="personal-details userdiv">
                <div class="row">
                    <div class="col-md-3 col-lg-3">
                        <h3 class="user" *ngIf="filteredData.length != 0">Tickets</h3>
                        <h3 class="user" *ngIf="UserfilteredData != 0">User Tickets</h3>
                        <h3 class="user1" *ngIf="searchedticketdata != 0">Tickets by {{customertype}}</h3>
                    </div>
                    <div class="col-md-9 col-lg-9" style="display: flex;padding-left: 0;justify-content: space-between;">
                        <div class="col-md-6 col-lg-6">
                          <select class="form-control" (change)="addTicketByMultiFieldSearch()" [(ngModel)]="customertype">
                            <option value="" disable selected hidden>---select type---</option>
                            <option *ngFor="let ticket of AllTickets" [value]="ticket.customerType">{{ticket.customerType}}</option>
                          </select>
                        </div>
                        <div class="pad" style="width:35%">
                            <input type="date" [(ngModel)]="Date1" class="form-control">
                        </div>
                        <div class="pad" style="width:35%">
                            <input type="date" [(ngModel)]="Date2" (change)="filterByTicketStatusAndBetweenDates()" class="form-control">
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <select class="form-control" (change)="getFilteredData()" [(ngModel)]="userId">
                                <option value="" disable selected hidden>---select user---</option>
                                <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                            </select>
                        </div>
                        <!-- <div class="" style="width:18%">
                            <button  class="btn btn-primary">search</button>
                        </div> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-lg-3">
                    </div>
                    <div class="col-md-9 col-lg-9" style="display: flex;padding-left: 0;justify-content: space-between;">
                        <!-- <div class="col-md-6 col-lg-6">
                            <select class="form-control" (change)="getFilteredData()" [(ngModel)]="userId">
                                <option value="" disable selected hidden>---select user---</option>
                                <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                            </select>
                        </div> -->
                        <!-- <div class="pad" style="width:35%">
                            <input type="date" [(ngModel)]="startDate" class="form-control">
                        </div>
                        <div class="pad" style="width:35%">
                            <input type="date" [(ngModel)]="endDate" class="form-control">
                        </div> -->
                        <!-- <div class="" style="width:18%">
                            <button (click)="getFilteredData()" class="btn btn-primary">search</button>
                        </div> -->
                    </div>
                </div>
                <div *ngIf="ticketdata">
                    <h4 class="text-center" *ngIf="filteredData.length == 0">No Tickets Available</h4>
                </div>
                <div *ngIf="userticket">
                    <h4 class="text-center" *ngIf="UserfilteredData == 0">No User Tickets Available</h4>
                </div>
                <div *ngIf="searchticket">
                  <h4 class="text-center" *ngIf="searchedticketdata == 0">No Tickets Available by {{customertype}}</h4>
                </div>
                <div class="userdiv" *ngIf="filteredData.length != 0">
                    <!-- <h3 class="user">Tickets</h3> -->
                    <table class="table table-striped" >
                        <thead>
                          <tr>
                            <th scope="col">Type Name</th>
                            <th scope="col">Assigned To</th>
                            <th scope="col">Description</th>
                            <th scope="col">Subject</th>
                            <th scope="col">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let filteredData of filteredData;let i = index">
                            <th scope="col">{{filteredData.typeName}}</th>
                            <th scope="col">{{filteredData.assignedToUserName}}</th>
                            <th scope="col">{{filteredData.details}}</th>
                            <th scope="col">{{filteredData.heading}}</th>
                            <th scope="col">{{filteredData.latestTicketStatus}}</th>
                          </tr>
                        </tbody>
                    </table>
                </div>
                <div class="userdiv" *ngIf="UserfilteredData != 0">
                    <!-- <h3 class="user">User Tickets</h3> -->
                    <table class="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Type Name</th>
                            <th scope="col">Assigned To</th>
                            <th scope="col">Description</th>
                            <th scope="col">Subject</th>
                            <th scope="col">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let filteredData of UserfilteredData;let i = index">
                            <th scope="col">{{filteredData.typeName}}</th>
                            <th scope="col">{{filteredData.assignedToUserName}}</th>
                            <th scope="col">{{filteredData.details}}</th>
                            <th scope="col">{{filteredData.heading}}</th>
                            <th scope="col">{{filteredData.latestTicketStatus}}</th>
                          </tr>
                        </tbody>
                    </table>
                </div>
                <div class="userdiv" *ngIf="searchedticketdata.length != 0">
                  <table class="table table-striped" >
                      <thead>
                        <tr>
                          <th scope="col">Type Name</th>
                          <th scope="col">Assigned To</th>
                          <th scope="col">Description</th>
                          <th scope="col">Subject</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let filteredData of searchedticketdata.ticketList;let i = index">
                          <th scope="col">{{filteredData.typeName}}</th>
                          <th scope="col">{{filteredData.assignedToUserName}}</th>
                          <th scope="col" style="width:30%">{{filteredData.details}}</th>
                          <th scope="col" style="width:30%">{{filteredData.heading}}</th>
                          <th scope="col">{{filteredData.latestTicketStatus}}</th>
                        </tr>
                      </tbody>
                  </table>
              </div>
            </div>

        </div>
    </div>
</div>